import { LuLoaderCircle } from "react-icons/lu";
import blueWave from "../../assets/blue_wave.mp4";
import darvinSadImage from "../../assets/darvin/darvin_sad.png";
import LogoWhite from "../../assets/logo/logo-white.svg?react";
import { useIsCompactView } from "../../core_stores/useIsCompactViewStore";
import { WelcomeFooter } from "../welcome/components/WelcomeFooter";

export function NoAccessContent({
  isLoading,
  info,
  actionBtn,
  showDarvin = true,
}: {
  isLoading: boolean;
  info: string;
  actionBtn?: {
    label: string;
    onClick: () => void;
  };
  showDarvin?: boolean;
}) {
  const isCompactView = useIsCompactView();

  return (
    <div
      className="relative w-[100dvw] h-[100dvh] overflow-hidden 
      flex flex-col z-50 bg-light-surface-primary dark:bg-dark-surface-primary"
    >
      <div className="flex-1 relative overflow-hidden">
        <video
          src={blueWave}
          autoPlay
          loop
          muted
          playsInline
          className="absolute right-0 top-0 w-full h-full 
            object-cover scale-[1.1]"
        />

        <div
          className="absolute inset-0 bg-gradient-to-t 
              from-light-surface-primary dark:from-dark-surface-primary 
              to-transparent"
        />
      </div>

      <div
        className={`${isCompactView ? "h-[400px]" : "h-[200px]"} w-full 
        bg-light-surface-primary dark:bg-dark-surface-primary`}
      />

      <div className="absolute inset-0 z-10 flex flex-col">
        <div className="p-5">
          <LogoWhite className="scale-[8.45] origin-left" />
        </div>

        <div className="flex-1 flex items-center justify-center px-6">
          {isLoading ? (
            <LoadingContent />
          ) : (
            <Info info={info} actionBtn={actionBtn} showDarvin={showDarvin} />
          )}
        </div>

        <WelcomeFooter />
      </div>
    </div>
  );
}

function LoadingContent() {
  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-4">
      <LuLoaderCircle className="animate-spin" size={32} />
      <p className="text-2xl font-bold mb-2">Loading...</p>
    </div>
  );
}

function Info({
  info,
  actionBtn,
  showDarvin = true,
}: {
  info: string;
  actionBtn?: {
    label: string;
    onClick: () => void;
  };
  showDarvin?: boolean;
}) {
  const isCompactView = useIsCompactView();

  return (
    <div
      className={`w-full max-w-[1000px] flex items-center ${
        isCompactView ? "flex-col pb-5 px-4" : ""
      }`}
    >
      {isCompactView && (
        <img
          src={darvinSadImage}
          alt="Sad Darvin robot"
          className="w-[300px] h-[300px] object-contain drop-shadow-[0_4px_8px_rgba(0,0,0,0.3)]"
        />
      )}

      <div
        className={`flex-1 flex flex-col items-center justify-center gap-3
      text-center ${
        isCompactView ? "text-light-text dark:text-dark-text" : "text-white"
      }`}
      >
        <p
          className={`${isCompactView ? "text-4xl" : "text-5xl"} 
        font-bold mb-2
        drop-shadow-[0_4px_4px_rgba(0,0,0,0.5)]`}
        >
          Sorry!
        </p>

        <p className="text-xl drop-shadow-[0_2px_2px_rgba(0,0,0,0.4)]">
          {info}
        </p>

        {actionBtn && (
          <button
            className="bg-primary-blue text-white px-4 py-2 mt-5 rounded-md
            hover:brightness-150 hover:cursor-pointer transition-all duration-300"
            onClick={actionBtn.onClick}
          >
            {actionBtn.label}
          </button>
        )}
      </div>

      {!isCompactView && showDarvin && (
        <img
          src={darvinSadImage}
          alt="Sad Darvin robot"
          className="w-[400px] h-[400px] object-contain drop-shadow-[0_4px_8px_rgba(0,0,0,0.3)]"
        />
      )}
    </div>
  );
}
